import React from 'react';
import PropTypes from 'prop-types';

export function InsuranceIcon({ title }) {
  return (
    <svg width="48" height="50" viewBox="0 0 48 50" fill="none" xmlns="http://www.w3.org/2000/svg" title={title}>
      <path d="M26.3337 0.333557H21.667V5.11542C11.4334 6.13148 3.14485 13.7594 1.13374 23.6669C0.827667 25.1747 0.666992 26.7354 0.666992 28.3335H21.6669L21.6667 40.5936C21.6667 45.4205 25.5797 49.3336 30.4067 49.3336C33.3802 49.3336 36.006 47.8465 37.5811 45.586L33.7523 42.918C33.0124 43.9799 31.7896 44.6669 30.4067 44.6669C28.1571 44.6669 26.3334 42.8432 26.3334 40.5936L26.3336 28.3335H47.3337C47.3337 26.7354 47.173 25.1747 46.8669 23.6669C44.8558 13.7594 36.5673 6.13148 26.3337 5.11542V0.333557ZM24.0003 9.66688C32.6982 9.66688 40.0067 15.6158 42.0789 23.6669H5.92174C7.99394 15.6158 15.3024 9.66688 24.0003 9.66688Z" fill="#FFFFFF" />
    </svg>
  );
}

InsuranceIcon.defaultProps = {
  title: '',
};

InsuranceIcon.propTypes = {
  title: PropTypes.string,
};
